export default function breadcrumbsDirective() {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/breadcrumbs/breadcrumbs-template.html",
		scope: {
			list: "<"
		}
	};
}
